module.exports = __webpack_public_path__ + "static/img/yk-code.ae37b67.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/image/yk-code.png
// module id = jGKd
// module chunks = 1 2 3 4 5 6